<script setup lang="ts">
  const projectConfig = useProjectConfig();

  useHead({
    link: [
      {
        rel: 'stylesheet',
        href: 'https://cdn.jsdelivr.net/npm/@almacareer/cookie-consent-manager@3/CookieConsentManager.min.css',
      },
    ],
    script: [
      {
        type: 'text/javascript',
        src: 'https://cdn.jsdelivr.net/npm/@almacareer/cookie-consent-manager@3/init.js',
        defer: true,
      },
    ],
  });

  onMounted(() => {
    if (
      'initCookieConsentManager' in window &&
      typeof window.initCookieConsentManager === 'function' &&
      projectConfig.features.almaCookieManager
    ) {
      window.initCookieConsentManager(projectConfig.domain, {
        translationOverrides: {
          hr: {
            preferencesModalMoreInfo: `Više informacija o tome što su kolačići i kako s njima radimo možete pronaći na stranici <a href="${projectConfig.parameters.cookiePolicyLink}" target="_blank">Politika Kolačića</a>.`,
          },
          bs: {
            preferencesModalMoreInfo: `Više informacija o tome što su kolačići i kako s njima radimo možete pronaći na stranici <a href="${projectConfig.parameters.cookiePolicyLink}" target="_blank">Politika Kolačića</a>.`,
          },
          en: {
            preferencesModalMoreInfo: `For more information about what cookies are and how we work with them, see our <a href="${projectConfig.parameters.cookiePolicyLink}" target="_blank">Cookie Policy</a>.`,
          },
        },
      });
    }
  });
</script>

<template>
  <span v-if="false" />
</template>
